// Copyright 2025, Imprivata, Inc.  All rights reserved.

import type { AuthenticatorCardProps } from './authenticatorCard/AuthenticatorCard';
import AuthenticatorCard from './authenticatorCard/AuthenticatorCard';
import './AuthenticatorList.less';

interface AuthenticatorListProps {
  title: string;
  cards: AuthenticatorCardProps[];
  emptyMessage?: string;
}

const AuthenticatorList = ({ title, emptyMessage, cards }: AuthenticatorListProps) => {
  return (
    <div className="list-details">
      {cards.length > 0 ? (
        <div>
          <span className="list-details-title">{title}</span>
          {cards.map(card => (
            <AuthenticatorCard
              key={card.title}
              icon={card.icon}
              title={card.title}
              subtitle={card.subtitle}
              data={card.data}
              enableRemove={card.enableRemove}
              onRemove={card.onRemove}
            />
          ))}
        </div>
      ) : (
        <p className="list-details-empty">{emptyMessage}</p>
      )}
    </div>
  );
};

export default AuthenticatorList;
